const isDev = process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};
